import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import EventListener from 'fbjs/lib/EventListener';
import domHelperContains from 'dom-helpers/query/contains';
import domHelperQuerySelectorAll from 'dom-helpers/query/querySelectorAll';
import { FormattedMessage } from 'react-intl';

import './NLMenu.css';

const DATA = [
  {
    title: <FormattedMessage id="TopMenu.home"/>,
    href: '/'
  },
  {
    title: <FormattedMessage id="TopMenu.company"/>,
    href: '/company'
  },
  {
    title: <FormattedMessage id="TopMenu.history"/>,
    href: '/history'
  },
  {
    title: <FormattedMessage id="TopMenu.salesItems"/>,
    href: '/sales-items'
  },
  {
    title: <FormattedMessage id="TopMenu.contact"/>,
    href: '/contact'
  }
];

class NLMenu extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    onClickClose: PropTypes.func
  };

  render() {
    return (
      <div 
        className={classnames('NLMenu', this.props.className, {
          open: this.props.isOpen
        })}
        ref="NLMenuNode">
        <div 
          className="NLMenu__closeBtn"
          onClick={this._close}>
          <div className="NLMenu__closeIcon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17">
              <g fill="#fff" fillRule="evenodd">
                <path d="M0.387104431,2.1977646 L14.5522354,16.3628956 C14.9364097,16.7470699 15.4852814,16.8210678 15.7781746,16.5281746 C16.0710678,16.2352814 15.9970699,15.6864097 15.6128956,15.3022354 L1.4477646,1.13710443 C1.0635903,0.752930128 0.514718626,0.678932188 0.221825407,0.971825407 C-0.0710678119,1.26471863 0.00293012774,1.8135903 0.387104431,2.1977646 Z"/>
                <path d="M1.4477646,16.3628956 L15.6128956,2.1977646 C15.9970699,1.8135903 16.0710678,1.26471863 15.7781746,0.971825407 C15.4852814,0.678932188 14.9364097,0.752930128 14.5522354,1.13710443 L0.387104431,15.3022354 C0.00293012774,15.6864097 -0.0710678119,16.2352814 0.221825407,16.5281746 C0.514718626,16.8210678 1.0635903,16.7470699 1.4477646,16.3628956 Z"/>
              </g>
            </svg>
          </div>
        </div>
        <nav className="NLMenu__navigation">
          <ul className="NLMenu__menuItems">
            {
              DATA.map(({ title, href }, idx) => (
                <li 
                  key={idx}
                  className="NLMenu__menuItem">
                  <Link
                    className="NLMenu__menuLink"
                    to={href}
                    onClick={this._close}
                    data-scroll="true">
                    {title}
                  </Link>
                </li>
              ))
            }
          </ul>
        </nav>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen) {
      this._attachScrollListener();
      this.refs.NLMenuNode.scrollTop = 0;
    } else {
      this._detachScrollListener();
    }
  }

  componentWillUnmount() {
    this._detachScrollListener();
  }

  _attachScrollListener = () => {
    this._detachScrollListener();
    this._mouseDownListener = EventListener.listen(document, 'mouseup', this._onClickOutside);
    this._touchStartListener = EventListener.listen(document, 'click', this._onClickOutside);
  };

  _detachScrollListener = () => {
    if (this._mouseDownListener) {
      this._mouseDownListener.remove();
      this._mouseDownListener = null;
    }
    if (this._touchStartListener) {
      this._touchStartListener.remove();
      this._touchStartListener = null;
    }
  };

  _onClickOutside = (evt) => {
    // NLTopBar의 메뉴버튼을 눌렀을 땐 무시. NLTopBar 내부에서 처리.
    const topBarMenuNode = domHelperQuerySelectorAll(document, '.MobileHeader__menuBtn')[0];

    // 사용자가 메뉴 바깥의 다른 것을 눌렀을 때 자동으로 메뉴 닫기.
    if (!this.props.isOpen ||
      evt.target.tagName === 'HTML' ||
      domHelperContains(this.refs.NLMenuNode, evt.target) || 
      (topBarMenuNode && domHelperContains(topBarMenuNode, evt.target))) {
      return;
    }
    evt.stopPropagation();
    this._close();
  };

  _onScrollThreshold = () => {
    // 사용자가 브라우저를 threshold 수치만큼 (88픽셀) 스크롤 했을 때 자동으로 메뉴 닫기.
    this._close();
  };

  _close = () => {
    this.props.onClickClose();
  };
  
}

export default NLMenu;



// WEBPACK FOOTER //
// ./src/components/NLMenu.js